import OEIconCodes from '../../../lib/oe-icon-codes';
import {OEObjectModelValueTypes, OEObjectModelValueCellStyleOptions} from '../../elements/object-model-value-edit/oe-object-model-value-edit-model';
import {OEFunctionFragmentType} from './function/oe-function-model';
import {OESmartAttributeType, OESmartAttributeIcons, OESmartAttributeParameterModel, OESmartAttributeHelperClass} from './smart-attribute/oe-smart-attribute-model';

export const OENoteEditModeFlags = {
    disabled:                               0,
    addNote:                                1,
    removeNote:                             2,
    addLinkPoint:                           4,
    removeLinkPoint:                        8,
    transformNote:                          16,
    transformLinkPoint:                     32
};

OENoteEditModeFlags.addRemoveNote           = OENoteEditModeFlags.addNote | OENoteEditModeFlags.removeNote;
OENoteEditModeFlags.addRemoveLinkPoint      = OENoteEditModeFlags.addLinkPoint | OENoteEditModeFlags.removeLinkPoint;
OENoteEditModeFlags.add                     = OENoteEditModeFlags.addNote | OENoteEditModeFlags.addLinkPoint;
OENoteEditModeFlags.remove                  = OENoteEditModeFlags.removeNote | OENoteEditModeFlags.removeLinkPoint;
OENoteEditModeFlags.addRemove               = OENoteEditModeFlags.add | OENoteEditModeFlags.remove;
OENoteEditModeFlags.transform               = OENoteEditModeFlags.transformNote | OENoteEditModeFlags.transformLinkPoint;
OENoteEditModeFlags.completeNote            = OENoteEditModeFlags.addRemoveNote | OENoteEditModeFlags.transformNote;
OENoteEditModeFlags.completeLinkPoint       = OENoteEditModeFlags.addRemoveLinkPoint | OENoteEditModeFlags.transformLinkPoint;
OENoteEditModeFlags.complete                = OENoteEditModeFlags.completeNote | OENoteEditModeFlags.completeLinkPoint;

//
export const OENoteEditDisplayFlags = {
    none:                                   0,
    showDocument:                           1,
    showVisibilityCheckSize:                2,
    all:                                    3
};

//
export const OENoteAddFlags = {
    none:                                   0,
    linkJoint:                              1,
    all:                                    1,
    default:                                1
};

//
export const OENoteFlags = {
    none:                                   0,
    stringEscaping:                         1,
    textViewerEditable:                     2,
    activeViewerEditable:                   4,
    linkPointViewerEditable:                8,
    all:                                    15
};

OENoteFlags.textActiveViewerEditable        = OENoteFlags.textViewerEditable | OENoteFlags.activeViewerEditable;
OENoteFlags.viewerEditable                  = OENoteFlags.linkPointViewerEditable | OENoteFlags.textActiveViewerEditable;
OENoteFlags.default                         = OENoteFlags.none;

//
export const OENoteViewerEditFlags = {
    none:                                   0,
    singleLine:                             1,
    autosave:                               2,
    default:                                0
};

//
export const OENoteStateBits = {
    none:                                   0,
    text:                                   1 << 0,
    hidden:                                 1 << 1,
    disabled:                               1 << 2,
    active:                                 1 << 3,
    params:                                 1 << 4,
    links:                                  1 << 5,
    addStates:                              1 << 6,
    attributes:                             1 << 7,
    all:                                    (1 << 8) - 1
};

OENoteStateBits.allButAddStates = OENoteStateBits.all ^ (OENoteStateBits.all & OENoteStateBits.addStates);
OENoteStateBits.allButAddStatesAttributes = OENoteStateBits.all ^ (OENoteStateBits.all & (OENoteStateBits.addStates | OENoteStateBits.attributes));

//
export const OENoteStyleBits = {
    none:                                   0,
    hAlignment:                             1 << 0,
    vAlignment:                             1 << 1,
    contentInset:                           1 << 2,
    cornerRadius:                           1 << 3,
    textColor:                              1 << 4,
    backgroundColor:                        1 << 5,
    borderColor:                            1 << 6,
    lineColor:                              1 << 7,
    hasBorder:                              1 << 8,
    fontSize:                               1 << 9,
    showAlways:                             1 << 10,
    maxWidth:                               1 << 11,
    maxScreenRelWidth:                      1 << 12,
    intrinsicSize:                          1 << 13,
    linkPointSize:                          1 << 14,
    all:                                    (1 << 15) - 1,
    MAX:                                    1 << 14
};

OENoteStyleBits.alignment = OENoteStyleBits.hAlignment | OENoteStyleBits.vAlignment;
OENoteStyleBits.colors = OENoteStyleBits.textColor | OENoteStyleBits.backgroundColor | OENoteStyleBits.borderColor | OENoteStyleBits.lineColor;
OENoteStyleBits.defaultStyleTransfer = OENoteStyleBits.all ^ (OENoteStyleBits.showAlways);

//
export const OENoteTransferPropertyBits = Object.assign({}, OENoteStyleBits, {
    zIndex:                                 OENoteStyleBits.MAX << 1,
    stringEscaping:                         OENoteStyleBits.MAX << 2,
    textViewerEditable:                     OENoteStyleBits.MAX << 3,
    activeViewerEditable:                   OENoteStyleBits.MAX << 4,
    linkPointViewerEditable:                OENoteStyleBits.MAX << 5,
    viewerEditSingleLine:                   OENoteStyleBits.MAX << 6,
    viewerEditAutosave:                     OENoteStyleBits.MAX << 7,
    viewerEditMaxTextLength:                OENoteStyleBits.MAX << 8,
    text:                                   OENoteStyleBits.MAX << 9,
    image:                                  OENoteStyleBits.MAX << 10,
    hidden:                                 OENoteStyleBits.MAX << 11,
    disabled:                               OENoteStyleBits.MAX << 12,
    active:                                 OENoteStyleBits.MAX << 13,
    style:                                  OENoteStyleBits.all,
    func:                                   OENoteStyleBits.MAX << 14,
    textID:                                 OENoteStyleBits.MAX << 15,
    visibilityCheckSize:                    OENoteStyleBits.MAX << 16,
    visibilityCheckRef:                     OENoteStyleBits.MAX << 17,
    all:                                    (OENoteStyleBits.MAX << 18) - 1,
    defaultPropTransfer:                    OENoteStyleBits.defaultStyleTransfer,
    MAX:                                    OENoteStyleBits.MAX << 17,
});

OENoteTransferPropertyBits.pureBitKeyArray = Object.keys(OENoteTransferPropertyBits).filter(key => !['MAX', 'all', 'alignment', 'colors', 'defaultStyleTransfer', 'style', 'defaultPropTransfer'].includes(key));

OENoteTransferPropertyBits.properBitKeyArray = Object.keys(OENoteTransferPropertyBits).filter(key => !['MAX', 'all', 'defaultStyleTransfer', 'defaultPropTransfer'].includes(key));

//
export const OENoteControllerBtnIds = {
    showDocument:                           'showDocument',
    showVisibilityCheckSize:                'showVisibilityCheckSize',
    orderViews:                             'orderViews'
};

//
export const OENoteExtControllerBtnIds = {
    loadRTFFile:                            'loadRTFFile',
    loadImage:                              'loadImage',
    dumpImage:                              'dumpImage'
};

//
export const OENoteStyleTransferControllerBtnIds = {
    deselectAllStyleTransferBits:           'deselectAllStyleTransferBits',
    selectAllStyleTransferBits:             'selectAllStyleTransferBits',
    transferToUserRef:                      'transferToUserRef',
    transferToAll:                          'transferToAll'
};

//
export const OENotePropertyTransferControllerBtnIds = {
    deselectAllStyleTransferBits:           'deselectAllStyleTransferBits',
    selectAllStyleTransferBits:             'selectAllStyleTransferBits',
    transferToUserRef:                      'transferToUserRef',
    transferToAll:                          'transferToAll'
};

//
export const OENoteAddStateControllerBtnIds = {
    newAddState:                            'newAddState',
    applyAddState:                          'applyAddState',
    dumpAddState:                           'dumpAddState',
    setAddState:                            'setAddState'
};

//
export const OENoteTextIDBits = {
    none:                                   0,
    unique:                                 1,
    complete:                               2,
    uniqueComplete:                         3,
    all:                                    3
};

//
export const OENoteModels = {

    styleExt: {
        maxWidth:                           {type: OEObjectModelValueTypes.float, allowUndefined: true, min: 10, max: 1000, step: 0.01, label: 'Max Width'},
        maxScreenRelWidth:                  {type: OEObjectModelValueTypes.float, allowUndefined: true, min: 0.1, step: 0.01, label: 'Max Screen Width'},
        intrinsicSize:                      {type: OEObjectModelValueTypes.vec2, allowUndefined: false, allowPartialUndefined: true, step: 0.001, label: 'Intrinsic Size'}
    },

    positioning: {
        zIndex:                             {type: OEObjectModelValueTypes.integer, allowUndefined: false, label: 'z-Index'}
    },

    visibility: {
        visibilityCheckRef:                 {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Check Reference'},
        visibilityCheckSize:                {type: OEObjectModelValueTypes.float, allowUndefined: true, min: 0.5, max: 300, step: 0.5, label: 'Visibility Check Size'}
    },

    misc: {
        userRef:                            {type: OEObjectModelValueTypes.string, label: 'User Reference'},
        textID:                             {type: OEObjectModelValueTypes.string, label: 'Text ID'},
        escaping:                           {type: OEObjectModelValueTypes.bool, label: 'Escaping Enabled', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
        hidden:                             {type: OEObjectModelValueTypes.bool, label: 'Hidden', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
        disabled:                           {type: OEObjectModelValueTypes.bool, label: 'Disabled', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
        textViewerEditable:                 {type: OEObjectModelValueTypes.bool, label: 'Text Viewer Editable', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
        activeViewerEditable:               {type: OEObjectModelValueTypes.bool, label: 'Viewer Activatable', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
        active:                             {type: OEObjectModelValueTypes.bool, label: 'Active', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
        linkPointViewerEditable:            {type: OEObjectModelValueTypes.bool, label: 'Link Point Viewer Editable', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
        viewEditParams: {
            type:                           OEObjectModelValueTypes.group,
            label:                          'Viewer Edit Parameters',
            styleOptions:                   [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.collapsible],
            collapsed:                      true,
            subItems: {
                singleLine:                 {type: OEObjectModelValueTypes.bool, label: 'Single Line', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                autosave:                   {type: OEObjectModelValueTypes.bool, label: 'Autosave', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                maxTextLength:              {type: OEObjectModelValueTypes.integer, allowUndefined: true, min: 0, label: 'Max Text Length', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        }
    },

    styleTransfer: {
        userRef:                            {type: OEObjectModelValueTypes.string, label: 'User Reference', labelId: 'note_style_transfer_user_reference', showType: false},
        parameters: {
            type:                           OEObjectModelValueTypes.group,
            label:                          'Style Parameters',
            labelId:                        'note_style_transfer_style_parameters',
            styleOptions:                   OEObjectModelValueCellStyleOptions.singleColumn,
            subItems: {
                alignment:                  {type: OEObjectModelValueTypes.bool, label: 'Alignment', labelId: 'note_style_transfer_alignment', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                contentInset:               {type: OEObjectModelValueTypes.bool, label: 'Inset', labelId: 'note_style_transfer_content_inset', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                fontSize:                   {type: OEObjectModelValueTypes.bool, label: 'Font Size', labelId: 'note_style_transfer_font_size', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                intrinsicSize:              {type: OEObjectModelValueTypes.bool, label: 'Intrinsic Size', labelId: 'note_style_transfer_intrinsic_size', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                linkPointSize:              {type: OEObjectModelValueTypes.bool, label: 'Point Size', labelId: 'note_style_transfer_link_point_size', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                maxWidth:                   {type: OEObjectModelValueTypes.bool, label: 'Max Width', labelId: 'note_style_transfer_max_width', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                maxScreenRelWidth:          {type: OEObjectModelValueTypes.bool, label: 'Max Screen Width', labelId: 'note_style_transfer_max_screen_width', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                cornerRadius:               {type: OEObjectModelValueTypes.bool, label: 'Corner Radius', labelId: 'note_style_transfer_corner_radius', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                hasBorder:                  {type: OEObjectModelValueTypes.bool, label: 'Border', labelId: 'note_style_transfer_has_border', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                textColor:                  {type: OEObjectModelValueTypes.bool, label: 'Text Color', labelId: 'note_style_transfer_text_color', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                backgroundColor:            {type: OEObjectModelValueTypes.bool, label: 'Background Color', labelId: 'note_style_transfer_background_color', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                borderColor:                {type: OEObjectModelValueTypes.bool, label: 'Border Color', labelId: 'note_style_transfer_border_color', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                lineColor:                  {type: OEObjectModelValueTypes.bool, label: 'Line Color', labelId: 'note_style_transfer_line_color', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        }
    },

    propertyTransfer: {
        userRef:                            {type: OEObjectModelValueTypes.string, label: 'User Reference', labelId: 'note_property_transfer_user_reference', showType: false},
        contentParameters: {
            type:                           OEObjectModelValueTypes.group,
            label:                          'Content Parameters',
            labelId:                        'note_property_transfer_content_parameters',
            styleOptions:                   [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.collapsible],
            collapsed:                      true,
            subItems: {
                text:                       {type: OEObjectModelValueTypes.bool, label: 'Text', labelId: 'note_property_transfer_text', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                image:                      {type: OEObjectModelValueTypes.bool, label: 'Image', labelId: 'note_property_transfer_image', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        },
        visibilityParameters: {
            type:                           OEObjectModelValueTypes.group,
            label:                          'Visibility Parameters',
            labelId:                        'note_property_transfer_visibility_parameters',
            styleOptions:                   [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.collapsible],
            collapsed:                      true,
            subItems: {
                visibilityCheckRef:         {type: OEObjectModelValueTypes.bool, label: 'Check Reference', labelId: 'note_property_transfer_visibility_check_ref', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                visibilityCheckSize:        {type: OEObjectModelValueTypes.bool, label: 'Visibility Check Size', labelId: 'note_property_transfer_visibility_check_size', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        },
        styleParameters: {
            type:                           OEObjectModelValueTypes.group,
            label:                          'Style Parameters',
            labelId:                        'note_property_transfer_style_parameters',
            styleOptions:                   [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.scrollable, OEObjectModelValueCellStyleOptions.collapsible],
            collapsed:                      false,
            subItems: {
                alignment:                  {type: OEObjectModelValueTypes.bool, label: 'Alignment', labelId: 'note_property_transfer_alignment', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                contentInset:               {type: OEObjectModelValueTypes.bool, label: 'Inset', labelId: 'note_property_transfer_content_inset', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                fontSize:                   {type: OEObjectModelValueTypes.bool, label: 'Font Size', labelId: 'note_property_transfer_font_size', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                intrinsicSize:              {type: OEObjectModelValueTypes.bool, label: 'Intrinsic Size', labelId: 'note_property_transfer_intrinsic_size', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                linkPointSize:              {type: OEObjectModelValueTypes.bool, label: 'Point Size', labelId: 'note_property_transfer_link_point_size', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                maxWidth:                   {type: OEObjectModelValueTypes.bool, label: 'Max Width', labelId: 'note_property_transfer_max_width', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                maxScreenRelWidth:          {type: OEObjectModelValueTypes.bool, label: 'Max Screen Width', labelId: 'note_property_transfer_max_screen_width', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                cornerRadius:               {type: OEObjectModelValueTypes.bool, label: 'Corner Radius', labelId: 'note_property_transfer_corner_radius', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                hasBorder:                  {type: OEObjectModelValueTypes.bool, label: 'Border', labelId: 'note_property_transfer_has_border', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                textColor:                  {type: OEObjectModelValueTypes.bool, label: 'Text Color', labelId: 'note_property_transfer_text_color', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                backgroundColor:            {type: OEObjectModelValueTypes.bool, label: 'Background Color', labelId: 'note_property_transfer_background_color', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                borderColor:                {type: OEObjectModelValueTypes.bool, label: 'Border Color', labelId: 'note_property_transfer_border_color', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                lineColor:                  {type: OEObjectModelValueTypes.bool, label: 'Line Color', labelId: 'note_property_transfer_line_color', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        },
    },

    propertyTransfer2: {
        miscParameters: {
            type:                           OEObjectModelValueTypes.group,
            label:                          'Miscellaneous Parameters',
            labelId:                        'note_property_transfer_miscellaneous_parameters',
            styleOptions:                   [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.scrollable, OEObjectModelValueCellStyleOptions.collapsible],
            collapsed:                      true,
            subItems: {
                func:                       {type: OEObjectModelValueTypes.bool, label: 'Function', labelId: 'note_property_transfer_function', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                zIndex:                     {type: OEObjectModelValueTypes.bool, label: 'z-Index', labelId: 'note_property_transfer_z_index', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                textID:                     {type: OEObjectModelValueTypes.bool, label: 'Text ID', labelId: 'note_property_transfer_text_id', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                hidden:                     {type: OEObjectModelValueTypes.bool, label: 'Hidden', labelId: 'note_property_transfer_hidden', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                disabled:                   {type: OEObjectModelValueTypes.bool, label: 'Disabled', labelId: 'note_property_transfer_disabled', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                stringEscaping:             {type: OEObjectModelValueTypes.bool, label: 'Escaping Enabled', labelId: 'note_property_transfer_string_escaping', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                textViewerEditable:         {type: OEObjectModelValueTypes.bool, label: 'Text Viewer Editable', labelId: 'note_property_transfer_text_viewer_editable', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                activeViewerEditable:       {type: OEObjectModelValueTypes.bool, label: 'Active Viewer Editable', labelId: 'note_property_transfer_active_viewer_editable', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                active:                     {type: OEObjectModelValueTypes.bool, label: 'Active', labelId: 'note_property_transfer_active', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                linkPointViewerEditable:    {type: OEObjectModelValueTypes.bool, label: 'Link Point Viewer Editable', labelId: 'note_property_transfer_link_point_viewer_editable', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                viewerEditSingleLine:       {type: OEObjectModelValueTypes.bool, label: 'Viewer Edit Single Line', labelId: 'note_property_transfer_viewer_edit_single_line', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                viewerEditAutosave:         {type: OEObjectModelValueTypes.bool, label: 'Viewer Edit Autosave', labelId: 'note_property_transfer_viewer_edit_autosave', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]},
                viewerEditMaxTextLength:    {type: OEObjectModelValueTypes.bool, label: 'Viewer Edit Max Text Length', labelId: 'note_property_transfer_viewer_edit_max_text_length', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.singleColumn, OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        },
    },

    addStateData: {
        userRef:                            {type: OEObjectModelValueTypes.string, label: 'User Reference', labelId: 'note_add_state_user_reference', showType: false},
    }
};

//
export const OENoteToolbarViewTypes = {
    function:                               'function',
    styleExt:                               'styleExt',
    propertyTransfer:                       'propertyTransfer',
    addState:                               'addState',
    attribute:                              'attribute'
};

//
export const OENoteFunctionDefinitions = {

    addFragmentMenuTypes: [
        OEFunctionFragmentType.setMediaCenterItem,
        OEFunctionFragmentType.showMedia,
        {type: OEFunctionFragmentType.setNoteText, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.changeNoteProps, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.applyNoteAddState, allowMultipleInstances: true},
        OEFunctionFragmentType.saveNote,
        {type: OEFunctionFragmentType.triggerNoteAttrSignal, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.changePresNoteProps, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.applyPresNoteAddState, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.triggerPresNoteAttrSignal, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.changeSlideProps, allowMultipleInstances: true},
        OEFunctionFragmentType.changeActiveSlide,
        OEFunctionFragmentType.userNotification,
        OEFunctionFragmentType.applyPreset,
        {type: OEFunctionFragmentType.changeComponent, allowMultipleInstances: true},
        //{type: OEFunctionFragmentType.debugOutput, allowMultipleInstances: true}
    ]
};

//
export const OENoteAttributeType = Object.assign({}, OESmartAttributeType, {
    noteDummy:                              10000,
    noteQuizQuest:                          10001,
    noteUserRef:                            10002,
    noteNoteUserRef:                        10003,
    noteQuizEval:                           10004,
    notePresQuizEval:                       10005,
});

//
export const OENoteAttributeIcons = Object.assign({}, OESmartAttributeIcons, {
    noteDummy:                              '\u00FF',
    noteQuizQuest:                          '\uF0E7',
    noteQuizEval:                           {code: '\uF0E7', subCode: '\uF123'},
    notePresQuizEval:                       {code: '\uF0E7', subCode: '\uF123', subCode2: OEIconCodes.presentation},
});

//
export const OENoteAttributeParameterModel = Object.assign({}, OESmartAttributeParameterModel, {

    noteQuizQuest: {
        texts:                              {type: OEObjectModelValueTypes.stringArray, showType: false},
        active:                             {type: OEObjectModelValueTypes.bool, allowUndefined: true, showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
        attachedComponentIDs:               {type: OEObjectModelValueTypes.string, undefinedEditable: true, showType: false}
    },

    noteQuizEval: {
        reference: {
            type:                           OEObjectModelValueTypes.group,
            label:                          'Referencing',
            subItems: {
                userRefs:                   {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Note User Reference', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        },
        persist:                            {type: OEObjectModelValueTypes.bool, label: 'Persist', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
    },

    notePresQuizEval: {
        reference: {
            type:                           OEObjectModelValueTypes.group,
            label:                          'Referencing',
            subItems: {
                userRefs:                   {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Note User Reference', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        },
        persist:                            {type: OEObjectModelValueTypes.bool, label: 'Persist', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
    }
});

//
export const OENoteAttributeHelper = new OESmartAttributeHelperClass(OENoteAttributeType, OENoteAttributeIcons, OENoteAttributeParameterModel);

OENoteAttributeHelper.addAttributeMenuTypes = [
    OESmartAttributeType.debugOutput,
    OENoteAttributeType.noteQuizQuest,
    {type: OENoteAttributeType.noteQuizEval, allowMultipleInstances: false, incompatibleTypes: OENoteAttributeType.notePresQuizEval},
    {type: OENoteAttributeType.notePresQuizEval, allowMultipleInstances: false, incompatibleTypes: OENoteAttributeType.noteQuizEval}
];

OENoteAttributeHelper.addEventFunctionMenuTypes = [
    {type: OEFunctionFragmentType.debugOutput, allowMultipleInstances: true},
    {type: OEFunctionFragmentType.setNoteText, allowMultipleInstances: true},
    {type: OEFunctionFragmentType.changeNoteProps, allowMultipleInstances: true},
    {type: OEFunctionFragmentType.applyNoteAddState, allowMultipleInstances: true},
    OEFunctionFragmentType.saveNote,
    {type: OEFunctionFragmentType.triggerNoteAttrSignal, allowMultipleInstances: true},
    {type: OEFunctionFragmentType.changePresNoteProps, allowMultipleInstances: true},
    {type: OEFunctionFragmentType.applyPresNoteAddState, allowMultipleInstances: true},
    {type: OEFunctionFragmentType.triggerPresNoteAttrSignal, allowMultipleInstances: true},
    {type: OEFunctionFragmentType.changeSlideProps, allowMultipleInstances: true},
    OEFunctionFragmentType.changeActiveSlide,
    OEFunctionFragmentType.userNotification,
    OEFunctionFragmentType.applyPreset,
    {type: OEFunctionFragmentType.changeComponent, allowMultipleInstances: true},
];